// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-container[data-v-9e2a317c] {\n  max-width: 400px;\n}", ""]);
// Exports
module.exports = exports;
